var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68251 15.5021C6.54001 15.5021 6.39751 15.4496 6.28501 15.3371C6.06751 15.1196 6.06751 14.7596 6.28501 14.5421L11.175 9.65215C11.535 9.29215 11.535 8.70715 11.175 8.34715L6.28501 3.45715C6.06751 3.23965 6.06751 2.87965 6.28501 2.66215C6.50251 2.44465 6.86251 2.44465 7.08001 2.66215L11.97 7.55215C12.3525 7.93465 12.57 8.45215 12.57 8.99965C12.57 9.54715 12.36 10.0646 11.97 10.4471L7.08001 15.3371C6.96751 15.4421 6.82501 15.5021 6.68251 15.5021Z",
    fill: "#868484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbArrow);
export default __webpack_public_path__ + "static/media/breadcrumb-arrow.308c77b4afcac9408336d42c10be44a1.svg";
export { ForwardRef as ReactComponent };